/** Which record a custom field belongs to (E2 RF-17). Mirrors the backend enum. */
export enum CustomFieldScopeEnum {
  CONTACT = 'CONTACT',
  CUSTOMER = 'CUSTOMER',
}
